// Format raw input to "+7 (XXX) XXX-XX-XX" mask.
// Always assumes Russian +7 prefix; accepts 10 digits user input or 11 starting with 7/8.
export function formatPhoneMask(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  let body = digits;
  if (body.startsWith('8')) body = '7' + body.slice(1);
  if (body.startsWith('7')) body = body.slice(1);
  body = body.slice(0, 10);
  const parts: string[] = ['+7'];
  if (body.length > 0) parts.push(' (' + body.slice(0, 3));
  if (body.length >= 3) parts[1] = ' (' + body.slice(0, 3) + ')';
  if (body.length > 3) parts.push(' ' + body.slice(3, 6));
  if (body.length > 6) parts.push('-' + body.slice(6, 8));
  if (body.length > 8) parts.push('-' + body.slice(8, 10));
  return parts.join('');
}

// Normalise to "+7XXXXXXXXXX" for submission.
export function normalisePhone(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  let body = digits;
  if (body.startsWith('8')) body = '7' + body.slice(1);
  if (!body.startsWith('7')) body = '7' + body;
  body = body.slice(0, 11);
  return '+' + body;
}
